import { Line } from 'react-chartjs-2'
import { colorPalette } from '../../utils/color-utils'
import { formatShortCurrency } from '../../utils/string-utils'

export default function ChartRevenueMonth({ data, title, label }: any) {
    const labels = data.map((item: any) => item.month)

    const datasets = [
        {
            label: label,
            data: data.map((item: any) => item.sum),
            borderWidth: 2,
            datalabels: {
                color: colorPalette[0],
            },
        },
    ]

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                },
                padding: {
                    bottom: 24,
                },
            },
            datalabels: {
                display: true,
                formatter: (_: any, value: any) => formatShortCurrency(data[value.dataIndex].sum),
                color: 'black',
                font: {
                    size: 14,
                    weight: 'bold',
                },
                anchor: 'end',
                align: 'top',
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: (value: any) => formatShortCurrency(value),
                },
            },
        },
    } as any

    return (
        <Line data={{ labels, datasets }} options={options} />
    )
}
